import { DateTime } from 'luxon';

const stringToDate = (value: string): Date => {
    return value.length === 10 ? DateTime.fromFormat(value, 'dd/MM/yyyy').toJSDate() : new Date('');
};

export const parseDateString = (_value: string, originalValue: Date | string): Date => {
    if (!originalValue) return new Date();
    if (originalValue instanceof Date) return originalValue;
    return stringToDate(originalValue as string);
};

export const dateToISOString = (value: string): string => {
    return DateTime.fromFormat(value, 'dd/MM/yyyy').toUTC().toISO() || '';
};

export const utcDateToISOString = (value: string): string => {
    return DateTime.fromFormat(value, 'dd/MM/yyyy', { zone: 'UTC' }).toISO() || '';
};

export const prettyDate = (value: string): string => {
    return DateTime.fromISO(value).toFormat('dd/MM/yyyy') || '';
};

export const boolToString = (value: boolean): string => (value ? 'yes' : 'no');

export const stringToBool = (value: string): boolean => value === 'yes';
